import React from 'react'
import {useLocation} from 'react-router-dom'
import Footer from '../../components/footer/Footer'
import PricingCardList from './components/pricingCardList/PricingCardList'
import {useMediaQuery} from 'react-responsive'
import './Pricing.scss'
import Button from '../../components/button/Button'
import {useHistory} from 'react-router'
import VO_SMILING_FEMALE__PRICE from '../../assets/VO_SMILING_FEMALE__Price.png'
import {useCountryContextContext} from '../../hooks/CountryContext'
import CountrySelection from '../../components/countrySelection/CountrySelection'

const answering = {
    title: `Answering Services Package`,
    subTitle: `Keep your business running with professional, 24/7 business phone
answering. 85% Of People Whose Calls Aren’t Answered Will Not Call
Back. Never Miss An Enquiry. Win More Business Opportunities with
our award-winning Live Telephone Answering Services.`,
    type: `answering`,
}
const dedicated = {
    title: `Dedicated Services Package`,
    subTitle: `Keep your business running with professional, 24/7 business phone answering. 85% Of People Whose Calls Aren’t Answered Will Not Call Back. Never Miss An Enquiry. Win More Business Opportunities with our award-winning Live Telephone Answering Services.`,
    type: `dedicated`,
}
const cayman = {
    title: `Cayman Services Package`,
    subTitle: `Keep your business running with professional, 24/7 business phone answering. 85% Of People Whose Calls Aren’t Answered Will Not Call Back. Never Miss An Enquiry. Win More Business Opportunities with our award-winning Live Telephone Answering Services.`,
    type: `cayman`,
}

const Pricing = () => {
    window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
    })
    // const [country, setCountry] = React.useState('')
    const history = useHistory()
    const isMobile = useMediaQuery({maxWidth: 755})
    const selectedCountry = useCountryContextContext()

    const {pathname} = useLocation()
    let pageType
    pathname.includes('answering') ? (pageType = answering) : (pageType = dedicated)
    if (selectedCountry.country.value === 'cayman') {
        pageType = cayman
    }
    // useEffect(() => {
    //   console.log(selectedCountry)
    //   setCountry(selectedCountry.country.value)
    // }, [selectedCountry.country.value])
    return (
        <div className="Pricing">
            <section className="Pricing__Wrapper">
                <div className="Pricing__Wrapper__Container page__padding">
                    <div className="headerSection">
                        <div
                            className="heading primary__heading heading">{pageType.title}</div>
                        <div className="subHeading">{pageType.subTitle}</div>
                        <CountrySelection/>
                    </div>
                    <PricingCardList type={pageType.type}/>
                </div>
            </section>
            <section className="more_features">
                <div className="more_features__wrapper">
                    <h1 className="primary__heading">
                        Need more features? Well, go ahead and call for your
                        own <span>customized</span> package.
                    </h1>
                    <p>
                        If you’re a business with a large call volume or unique business
                        model, reach out to discuss
                        alternative pricing options. Our teams will review your current
                        statements and can help design a
                        customized pricing package.
                    </p>
                    <Button
                        onclick={() =>
                            history.push({
                                pathname: '/customize',
                                state: {type: 'customize', subtype: 'customize'}
                            })
                        }
                        type="secondary"
                        text={'Contact Sales'}
                    />
                </div>
                <div>{isMobile &&
                <img className="smiling_female" src={VO_SMILING_FEMALE__PRICE}
                     alt=""/>}</div>
            </section>
            <Footer/>
        </div>
    )
}

export default Pricing
